<template>
  <section>
    <m-table-list ref="tableList" :is-init-list="false" :fetch-list-func="fetchListFunc" :search-form.sync="filters">
      <!--    <m-table-list ref="tableList" :search-form.sync="filters">-->
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
          <el-button style="float: right" @click="$router.push({name:'usermange.loginManage.userList'})">返回</el-button>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column label="登录账号" prop="userName" align="center"></el-table-column>
        <el-table-column label="IP" prop="loginIp" align="center"></el-table-column>
        <el-table-column label="时间" prop="loginTime" align="center">
          <template slot-scope="{row}">{{ row.loginTime | dateTime('yyyy-MM-dd hh:mm') }}</template>
        </el-table-column>
        <el-table-column label="登陆方式" prop="loginType" align="center">
          <template slot-scope="{row}">{{ row.loginType===1?'PC':'' }}</template>
        </el-table-column>
      </template>
    </m-table-list>
  </section>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";

export default {
  name: "usermange.loginManage.logList",
  data() {
    return {
      filters: {
        userId: ""
      }
    };
  },
  watch:{
    filter:{
      handler(val){

        this.$refs.tableList.handleSearch();
      },
      deep:true
    }
  },
  components: {
    "m-table-list": tableList,
  },
  activated() {
    this.filters.userId = this.$route.query.id;
    this.handleSearch()
    /*this.filters.userId = this.$route.query.id;
    //
    //
    this.handleSearch()*/
  },
  deactivated() {
    this.filters = {
      userId: ""
    }
  },
  methods: {
    fetchListFunc: api.log.getLoginLogList,
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.$refs.tableList.resetSearchForm();
    },
  },
};
</script>
